var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fullCalendar',{ref:"calendar",attrs:{"default-view":"dayGridMonth","plugins":_vm.calendarPlugins,"events":_vm.events,"selectable":true,"header":_vm.header,"button-icons":_vm.buttonIcons,"select-helper":true,"editable":true},on:{"dateClick":_vm.dateClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }